// @ts-nocheck
import loadStoreListData from "@store/Framework/Store/Data/StoreLists/Handlers/LoadStoreList";
import { StoreListModel } from "@store/Framework/Types/ApiModels";
import { GetStoreListsApiParameter } from "@store/Services/StoreListService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<{ storeListId: string }, GetStoreListsApiParameter, StoreListModel>;

export const DispatchSetStoreListId: HandlerType = props => {
    props.dispatch({
        type: "Pages/StoreListDetails/SetStoreListId",
        storeListId: props.parameter.storeListId,
    });
};

export const DispatchLoadStoreList: HandlerType = props => {
    props.dispatch(
        loadStoreListData({
            storeListId: props.parameter.storeListId,
        }),
    );
};

export const chain = [DispatchSetStoreListId, DispatchLoadStoreList];

const loadStoreList = createHandlerChainRunner(chain, "LoadStoreList");
export default loadStoreList;
